module.exports = __webpack_public_path__ + "static/media/DSC_0054-Edit.73884a0a.jpg";